/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="working-hours" v-if="viewWorkingHours && Object.keys(working_hours).length">
    <div role="tablist" class="accordion-list">
      <b-card no-body>
        <b-card-header header-tag="header" role="tab">
          <button v-b-toggle="'accordion-wh'" class="btn btn-none accordion-title w-100 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <svg class="o-icon"><use xlink:href="#clock"></use></svg>
              <template v-if="!getToday.off">
                <span class="open-close ml-2">
                  {{ $t('storelocator.close-whole-day') }}
                </span>
              </template>
              <template v-else>
                <span class="open-close ml-2 text-capitalize">
                  {{ getToday.openingStatement.isOpen ? $t('is-open') : $t('closed') }}
                </span>
                <span class="divisor mx-1">|</span>
                <span class="open-close-at">
                  {{getToday.openingStatement.isOpen ?
                    `${$t('close-at')} ${getToday.openingStatement.closeAt }`
                    :
                    `${$t('open-at')} ${getToday.openingStatement.openAt }`
                  }}
                </span>
              </template>
            </div>
            <svg class="o-icon"><use xlink:href="#arrow-down"></use></svg>
          </button>
        </b-card-header>
        <b-collapse id="accordion-wh" :visible="editMode" accordion="working-hours" role="tabpanel">
          <b-card-body>
            <ul class="wh-list" :class="{ 'edit-mode' : editMode }" >
              <li class="wh-list__item" v-for="(wh, index) in working_hours" :key="index">
                <div class="wrapp-text">
                  <div class="left-block">
                    <b-form-group v-if="editMode" class="ml-2">
                      <base-check-box
                        :name="`wh-off-${index}`"
                        v-model="wh.off"
                        :switchVal="true"
                      >
                      </base-check-box>
                    </b-form-group>
                    <span class="label">{{wh.localizedValue}}</span>
                  </div>
                  <div class="wh" v-if="wh.off">
                    <!-- FROM -->
                    <b-form-group>
                      <base-input
                        :name="`wh-from-${index}`"
                        type="text"
                        v-validate="'required|date_format:H:mm'"
                        v-model="wh.from"
                        placeholder="9:00"
                        :readonly="!editMode"
                        :validations="[
                          {
                            condition: errors.has(`wh-from-${index}`),
                            text: errors.first(`wh-from-${index}`)
                          }
                        ]"
                      >
                      </base-input>
                    </b-form-group>
                    <b-form-group>
                      <base-select
                        :name="`wh-meridian-from-${index}`"
                        v-model="wh.meridians.from"
                        :clearable="false"
                        :disabled="!editMode"
                        :searchable="false"
                        :options="meridianOption"
                      />
                    </b-form-group>
                    <!-- END FROM -->
                    <!-- TO -->
                    <span class="separator">–</span>
                    <b-form-group>
                      <base-input
                        :name="`wh-to-${index}`"
                        v-validate="'required|date_format:H:mm'"
                        v-model="wh.to"
                        type="text"
                        placeholder="8:00"
                        :readonly="!editMode"
                        :validations="[
                          {
                            condition: errors.has(`wh-to-${index}`),
                            text: errors.first(`wh-to-${index}`)
                          }
                        ]"
                      >
                      </base-input>
                    </b-form-group>
                    <b-form-group>
                      <base-select
                        :name="`wh-meridian-to-${index}`"
                        v-model="wh.meridians.to"
                        :options="meridianOption"
                        :clearable="false"
                        :searchable="false"
                        selected="pm"
                        :disabled="!editMode"
                      />
                    </b-form-group>
                    <!-- END TO -->
                  </div>
                </div>
              </li>
            </ul>
            <div class="wrapp-submit" v-show="editMode">
              <button class="btn btn-primary btn-primary-small btn-primary-black btn-rounded" @click.prevent="storeWorkingHours">
                <span class="text">
                  {{ $t('Submit') }}
                </span>
              </button>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import BaseInput from 'theme/components/Form/BaseInput'
import BaseCheckBox from 'theme/components/Form/BaseCheckBox'
import BaseSelect from 'theme/components/Form/BaseSelect'

dayjs.extend(isoWeek)

export default {
  name: 'CardBoutique',
  props: {
    workingHours: {
      type: Object | Array,
      required: true
    },
    viewWorkingHours: {
      type: Boolean,
      default: false
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  $_veeValidate: {
    validator: 'new',
    name: 'wh'
  },
  data () {
    return {
      weekdays: [],
      working_hours: {},
      isOpenNow: false,
      closeTimeForToday: '',
      meridianOption: ['am', 'pm'],
      meridianSelected: 'am',
      getToday: false,
      today: dayjs()
    }
  },
  computed: {
    language () {
      return this.$store.getters['storeConfig/language']
    }
  },
  methods: {
    initCalendars () {
      // set default
      dayjs.locale('en')
      this.weekdays = dayjs.weekdays()
      // set current
      dayjs.locale(this.language)
      let localizedWeeks = dayjs.weekdays()
      this.weekdays = this.weekdays.map((day, index) => {
        return {
          localizedValue: localizedWeeks[index], // Localized
          defaultValue: day.toLowerCase() // EN
        }
      })
    },
    initWorkingHours () {
      if (this.viewWorkingHours) {
        let wh = { ...this.workingHours }
        // Loop every week days
        for (let i = 0; i < this.weekdays.length; i++) {
          // find on object key === to current days
          // otherwise use everyday as key
          let weekName = wh[this.weekdays[i].defaultValue] ? this.weekdays[i].defaultValue : 'everyday'
          let from = wh[weekName].from
          let to = wh[weekName].to
          wh[this.weekdays[i].defaultValue] = {
            // day name
            defaultValue: this.weekdays[i].defaultValue,
            localizedValue: this.weekdays[i].localizedValue,
            // used in save call
            from: from.slice(0, 5).trim(),
            off: !parseInt(wh[weekName].off),
            to: to.slice(0, 5).trim(),
            // used for inputs
            meridians: {
              from: wh[weekName].from.slice(0, 2) <= '12' ? 'am' : 'pm',
              to: wh[weekName].to.slice(0, 2) <= '12' ? 'am' : 'pm'
            }
          }
          if (i === this.today.isoWeekday()) {
            this.getToday = {
              off: wh[weekName].off,
              openingStatement: {
                // Convert AM|PM to 24h to compare
                isOpen: dayjs(this.today).format('HH:mm') <= dayjs(to, 'hh:mm A').format('HH:mm'),
                closeAt: to,
                openAt: from
              }
            }
          }
        }
        if (wh.everyday) {
          delete wh.everyday
        }
        this.working_hours = wh
        return this.working_hours
      }
    },
    storeWorkingHours () {
      const _this = this
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          let data = []
          let workH = _this.working_hours
          for (let i in workH) {
            data.push(`${i}: ${workH[i].from}-${workH[i].to}`)
          }
          _this.$emit('updateWorkingHours', { data, useKeyForCall: 'updateWorkingHoursStore' })
        }
      })
    }
  },
  watch: {
    editMode: function (value) {
      if (!value) {
        this.initWorkingHours()
      }
    }
  },
  mounted () {
    if (process.client) {
      this.initCalendars()
      this.initWorkingHours()
      EventBus.$on('storeLocator:storeUpdated', this.initWorkingHours)
    }
  },
  destroyed () {
    EventBus.$off('storeLocator:storeUpdated', this.initWorkingHours)
  },
  components: {
    BaseInput,
    BaseCheckBox,
    BaseSelect
  }
}
</script>
